import { createContext, PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { Integration } from '../../../shared/interfaces/integration';

interface EditPipelineContextState {
  pipeline: Integration | null;
}

interface EditPipelineContextActions {
  updatePipeline: (pipeline: Integration) => void;
}

export type EditPipelineContextReturnType = EditPipelineContextState & EditPipelineContextActions;

const initialState: EditPipelineContextState = {
  pipeline: null
};

export const EditPipelineContext = createContext<EditPipelineContextReturnType>({
  ...initialState,
  updatePipeline: () => {}
});

export function EditPipelineContextProvider({ children }: PropsWithChildren) {
  const [state, setState] = useState(initialState);

  const updatePipeline = useCallback((pipeline: Integration) => {
    setState(prevState => ({ ...prevState, pipeline }));
  }, []);

  const providerValues: EditPipelineContextState & EditPipelineContextActions = useMemo(() => {
    return {
      ...state,
      updatePipeline
    };
  }, [state, updatePipeline]);

  return (
    <EditPipelineContext.Provider value={providerValues}>{children}</EditPipelineContext.Provider>
  );
}
